import { Link } from "@tanstack/react-router";
import { useBrand, useSiteSection, waLink } from "@/hooks/useSiteContent";
import { Logo } from "./Header";

function FooterLink({ to, label }: { to: string; label: string }) {
  const cls = "text-brand-sky transition-colors hover:text-brand-yellow";
  if (/^https?:/.test(to)) {
    return (
      <a href={to} target="_blank" rel="noreferrer" className={cls}>
        {label}
      </a>
    );
  }
  return (
    <Link to={to} className={cls}>
      {label}
    </Link>
  );
}

export function Footer() {
  const brand = useBrand();
  const footer = useSiteSection("footer");
  const columns = footer.columns ?? [];

  return (
    <footer className="bg-brand-deep text-brand-deep-foreground">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-9 px-5 py-10 sm:gap-10 sm:py-14 md:grid-cols-2 lg:grid-cols-[1fr_repeat(3,minmax(0,0.8fr))]">
        <div className="col-span-2 md:col-span-1">
          <a
            href={waLink(brand.whatsapp, "Olá! Vim pelo site da Contato.", "rodapé")}
            data-wa-loc="rodape"
            target="_blank"
            rel="noreferrer"
            className="inline-flex rounded-full bg-brand-yellow px-5 py-2.5 text-sm font-extrabold text-brand-yellow-foreground"
          >
            Falar no WhatsApp
          </a>
          <ul className="mt-6 space-y-1 text-sm text-brand-sky [overflow-wrap:anywhere]">
            <li>{brand.phoneDisplay}</li>
            <li>{brand.email}</li>
            <li>{footer.supportNote}</li>
          </ul>
        </div>

        {columns.map((col) => (
          <div key={col.title} className="min-w-0">
            <h3 className="text-sm font-extrabold uppercase tracking-widest text-brand-yellow">
              {col.title}
            </h3>
            <ul className="mt-4 space-y-2 text-sm">
              {(col.links ?? []).map((l) => (
                <li key={`${col.title}-${l.label}`}>
                  <FooterLink to={l.to} label={l.label} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-brand-sky/20 px-5 py-5">
        <p className="mx-auto max-w-7xl text-center text-xs text-brand-sky [overflow-wrap:anywhere] sm:text-left">
          © {new Date().getFullYear()} Contato Internet LTDA — 07.562.175/0001-31. Todos os
          direitos reservados.
        </p>
      </div>
    </footer>
  );
}
